import { useEffect } from "react";
import type { BreadcrumbItem } from "@/shell";
import { useBreadcrumbContext } from "@/shell/useBreadcrumbContext";

/** Set shell breadcrumbs for the active page. */
export function usePageBreadcrumbs(items: BreadcrumbItem[]) {
  const { setItems } = useBreadcrumbContext();
  const serialized = JSON.stringify(items);

  useEffect(() => {
    setItems(JSON.parse(serialized) as BreadcrumbItem[]);
  }, [serialized, setItems]);
}
